import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 50px;
`;

const Typography = styled.p`
  font-size: 25px;
  text-align: center;
`;

export {
  Container,
  Typography,
};
